import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const IconWrapper = styled.span`
  ${({ theme }) => css`
    display: flex;
    border-radius: 1000px;
    background-color: ${theme.v2.colors.feedback.problemUltraLight};
    padding: 12px;
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    margin-top: 8px;
    max-width: 300px;
    text-align: center;
    font-size: ${theme.v2.font.sizes.md};
    line-height: 1.25;
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.brand.primaryExtraDark};
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    margin-top: 8px;
    text-align: center;
    font-size: ${theme.v2.font.sizes.xxxs};
    line-height: 1.4;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 24px;
    display: flex;
    flex-direction: row;
    gap: 24px;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }
  `}
`;

export const CancelButton = styled.button`
  ${({ theme }) => css`
    cursor: pointer;
    border-radius: 1000px;
    border: 1px solid ${theme.v2.colors.feedback.problemMedium};
    padding: 8px 16px;
    color: ${theme.v2.colors.feedback.problemMedium};
    background: transparent;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    transition: all 0.2s ease;

    &:hover {
      background-color: ${theme.v2.colors.feedback.problemUltraLight};
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${theme.v2.colors.feedback.problemLight};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;
